module.exports = [{
      plugin: require('/codebuild/output/src214916767/src/node_modules/gatsby-plugin-rollbar/gatsby-browser'),
      options: {"plugins":[],"captureUncaught":true,"captureUnhandledRejections":true,"payload":{"environment":"production"}},
    },{
      plugin: require('/codebuild/output/src214916767/src/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
